import './MultiSelect.scss';
import React from 'react'
import { MultiSelect as PrMultiSelect } from 'primereact/multiselect';
import classNames from 'classnames'

function MultiSelect({ className, panelClassName,...restProps }) {
  return (
    <PrMultiSelect className={classNames('MultiSelect', className)}  panelClassName={classNames('MultiSelectPanel', panelClassName)} {...restProps}>
      {restProps.children}
    </PrMultiSelect>
  )
}

export default MultiSelect
